import { useTranslation } from "react-i18next";
const UserTip = ({ classNames = "" }: { classNames?: string }) => {
  const { t } = useTranslation();
  const agreement = t("login.agreement", { returnObjects: true }) as string[];

  return (
    <div
      className={`text-[#333] text-[12px] font-bold] text-center mt-[24px]
    ${classNames}`}
    >
      <span>{agreement[0]}</span>
      <a
        className="text-[#333] font-['Mulish'] font-[700] ms-1"
        href="https://h5.buscari.com/in/art/Buscari_Android_Privacy_Policy"
        target="_blank"
      >
        {agreement[1]}
      </a>
      <span className="mx-1">{agreement[2]}</span>
      <a
        className="text-[#333] font-bold font-['Mulish']"
        href="https://h5.buscari.com/in/art/Buscari_Android_User_Agreement"
        target="_blank"
      >
        {agreement[3]}
      </a>
    </div>
  );
};
export default UserTip;
